export class Color {
  constructor(
    public readonly id: string,
    public readonly name: string,
    public readonly enabled: boolean,
    public readonly color: string,
    public readonly colorName: string,
  ) {}

  static fromJson(json: any): Color {
    return new Color(
      json['id'],
      json['name'],
      json['enabled'],
      json['color'],
      json['colorName'],
    );
  }
}

type ColorConfig = {
  marker: string
  markerBorder: string
  avatar: string
  dot: string
}

const colors: Record<string, ColorConfig> = {
  orange: {
    marker: 'text-orange-600',
    markerBorder: 'border-orange-600',
    avatar: 'bg-orange-100 text-orange-800',
    dot: 'bg-orange-500',
  },
  zinc: {
    marker: 'text-zinc-600',
    markerBorder: 'border-zinc-600',
    avatar: 'bg-zinc-100 text-zinc-800',
    dot: 'bg-zinc-500',
  },
  amber: {
    marker: 'text-amber-600',
    markerBorder: 'border-amber-600',
    avatar: 'bg-amber-100 text-amber-800',
    dot: 'bg-amber-500',
  },
  purple: {
    marker: 'text-purple-600',
    markerBorder: 'border-purple-600',
    avatar: 'bg-purple-100 text-purple-800',
    dot: 'bg-purple-500',
  },
  indigo: {
    marker: 'text-indigo-600',
    markerBorder: 'border-indigo-600',
    avatar: 'bg-indigo-100 text-indigo-800',
    dot: 'bg-indigo-500',
  },
  green: {
    marker: 'text-green-600',
    markerBorder: 'border-green-600',
    avatar: 'bg-green-100 text-green-800',
    dot: 'bg-green-500',
  },
  red: {
    marker: 'text-red-600',
    markerBorder: 'border-red-600',
    avatar: 'bg-red-100 text-red-800',
    dot: 'bg-red-500',
  },
  lime: {
    marker: 'text-lime-600',
    markerBorder: 'border-lime-600',
    avatar: 'bg-lime-100 text-lime-800',
    dot: 'bg-lime-500',
  },
  fuchsia: {
    marker: 'text-fuchsia-600',
    markerBorder: 'border-fuchsia-600',
    avatar: 'bg-fuchsia-100 text-fuchsia-800',
    dot: 'bg-fuchsia-500',
  },
  yellow: {
    marker: 'text-yellow-600',
    markerBorder: 'border-yellow-600',
    avatar: 'bg-yellow-100 text-yellow-800',
    dot: 'bg-yellow-500',
  },
  sky: {
    marker: 'text-sky-600',
    markerBorder: 'border-sky-600',
    avatar: 'bg-sky-100 text-sky-800',
    dot: 'bg-sky-500',
  },
  stone: {
    marker: 'text-stone-600',
    markerBorder: 'border-stone-600',
    avatar: 'bg-stone-100 text-stone-800',
    dot: 'bg-stone-500',
  },
  blue: {
    marker: 'text-blue-600',
    markerBorder: 'border-blue-600',
    avatar: 'bg-blue-100 text-blue-800',
    dot: 'bg-blue-500',
  },
  cyan: {
    marker: 'text-cyan-600',
    markerBorder: 'border-cyan-600',
    avatar: 'bg-cyan-100 text-cyan-800',
    dot: 'bg-cyan-500',
  },
  neutral: {
    marker: 'text-neutral-600',
    markerBorder: 'border-neutral-600',
    avatar: 'bg-neutral-100 text-neutral-800',
    dot: 'bg-neutral-500',
  },
  pink: {
    marker: 'text-pink-600',
    markerBorder: 'border-pink-600',
    avatar: 'bg-pink-100 text-pink-800',
    dot: 'bg-pink-500',
  },
  emerald: {
    marker: 'text-emerald-600',
    markerBorder: 'border-emerald-600',
    avatar: 'bg-emerald-100 text-emerald-800',
    dot: 'bg-emerald-500',
  },
  slate: {
    marker: 'text-slate-600',
    markerBorder: 'border-slate-600',
    avatar: 'bg-slate-100 text-slate-800',
    dot: 'bg-slate-500',
  },
  rose: {
    marker: 'text-rose-600',
    markerBorder: 'border-rose-600',
    avatar: 'bg-rose-100 text-rose-800',
    dot: 'bg-rose-500',
  },
  violet: {
    marker: 'text-violet-600',
    markerBorder: 'border-violet-600',
    avatar: 'bg-violet-100 text-violet-800',
    dot: 'bg-violet-500',
  },
  gray: {
    marker: 'text-gray-600',
    markerBorder: 'border-gray-600',
    avatar: 'bg-gray-100 text-gray-800',
    dot: 'bg-gray-500',
  },
  teal: {
    marker: 'text-teal-600',
    markerBorder: 'border-teal-600',
    avatar: 'bg-teal-100 text-teal-800',
    dot: 'bg-teal-500',
  },
}

export function getColor(color: string): ColorConfig {
  return (
    colors[color] ?? {
      avatar: 'bg-gray-100 text-gray-800',
      dot: 'bg-gray-500',
    }
  )
}
